export default {
  name: '招聘职位',
  title: '标题',
  companyName: '公司',
  jobName: '职位',
  pleaseSelect: '请选择',
  jobSearchKeywordPlaceholder: '请输入职位名称',
  jobSearchBtn: '搜索职位',
  noData: '无数据',
  noMatchedData: '无匹配数据',
  selectAll: '全选',
  releaseDate: '发布时间：',
  roleType: '职责类型',
  workExp: '工作经验',
  workTime: '工作时间',
  workExpNotLimited: '不限',
  workExpYear: '年',
  showMoreJobs: '查看更多职位',
  location: {
    prefix: '等',
    suffix: '个地址'
  }
}
